import { AuthProvider, AuthProviderProps } from "react-oidc-context";
import { COGNITO_AUTHORITY, COGNITO_CLIENT_ID, LOGIN_URL } from "./constants";

const cognitoAuthConfig: AuthProviderProps = {
    authority: COGNITO_AUTHORITY,
    client_id: COGNITO_CLIENT_ID,
    redirect_uri: LOGIN_URL,
    response_type: "code",
    scope: "email openid phone",
    onSigninCallback: (_user) => {
        window.history.replaceState({}, document.title, window.location.pathname);
    },
};

export const AuthContextProvider = (props: { children: React.ReactNode }) => {
    return <AuthProvider {...cognitoAuthConfig}>
        {props.children}
    </AuthProvider>
}